import { render } from "./Authenticated.vue?vue&type=template&id=f4bf7440"
import script from "./Authenticated.vue?vue&type=script&lang=js"
export * from "./Authenticated.vue?vue&type=script&lang=js"

import exportComponent from "/home/forge/youth-elect.psppm.org.my/releases/69132554/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__